<div class="additional-product-attach">
  <div class="warning-message-container" *ngIf="warning.isShowWarning">
    <img src="assets/icons/warning-red.svg" />
    <div class="warning-message-container__message">
      <span class="warning-message-container__message-header">{{ "LABELS.NOTE" | translate }}!</span>
      <span class="warning-message-container__message-text">
        {{ warning.message }}
      </span>
    </div>
  </div>
  <div class="description-container">
    <div class="description-container__text">
      <span class="description">
        {{ (isIsf ? "LABELS.ISF_CRUCIAL_STEP" : "LABELS.ES_BOX_DESCRIPTION") | translate }}
      </span>
      <span *ngIf="!isProductRequested" class="clear-customs">
        {{ "LABELS.CLEAR_CUSTOMS" | translate : { product: productName(isIsf) } }}
      </span>
    </div>
    <div class="description-container__file" *ngIf="isProductRequested">
      <div class="file-button" (click)="onFileAdditionalDocs()">{{ "LABELS.FILE_NOW" | translate }}</div>
    </div>
  </div>
  <ng-content *ngIf="!isProductRequested" select="[radio]"></ng-content>
</div>
